/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import Text from "components/Common/Text";
import { Button } from "components/Common/button";
import { nameInitials } from "components/Scorecard/components/scorecardItem/nameInitials";
import { formatFirestoreTimeStamp } from "utils";
import Switch from "components/Common/switch";
import { updateHomeCourse } from "services/firebase";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import AlertContext from "components/Common/ModalAlert";

export default function ConfirmScoreModal({
  users,
  date,
  courseName,
  onSubmit,
  submitButtonDisable,
}) {
  const { eventId, teeTimeId, teamId } = useParams();
  const formatDate = formatFirestoreTimeStamp(date, "EEE, MMM d") ?? "";

  const { info } = useContext(AlertContext);

  const updateHomeHourseForUser = async (userData) => {
    try {
      await updateHomeCourse(
        eventId,
        teeTimeId,
        userData,
        !userData.isHomeCourse,
      );
    } catch (error) {
      info("We can't set checkbox :(");
    }
  };

  return (
    <div
      style={{
        overflow: "auto",
      }}
    >
      <div
        style={{
          padding: 28,
          width: "100%",
        }}
      >
        <Text
          as="H2"
          bold
          style={{
            color: "#232C2E",
          }}
        >
          ⛳️ {formatDate}
        </Text>
        <Text
          as="P3"
          style={{
            color: "#5C6363",
          }}
        >
          {courseName}
        </Text>
        <Text
          as="P2"
          bold
          style={{
            color: "#232C2E",
          }}
          mt={16}
        >
          Congratulations on completing your round!
        </Text>
        <Text
          as="C1"
          style={{
            color: "#232C2E",
          }}
          mt={4}
        >
          Please take a moment to review and confirm your scores. Did you play
          on your USGA homecourse? Toggle the switch to let us know.
        </Text>
      </div>
      <ListHeader
        title={["Player", "GROSS\nto Par", "NET\nto Par", "HOME COURSE?"]}
        users={users}
        setHomeCourse={(userData) => updateHomeHourseForUser(userData)}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: 32,
          marginBottom: 32,
        }}
      >
        <Button
          title="SUBMIT"
          style={{ width: "80%" }}
          onPress={onSubmit}
          blocked={submitButtonDisable}
        />
      </div>
    </div>
  );
}

function ListHeader({ title, users, setHomeCourse }) {
  return (
    <>
      <div
        style={{
          backgroundColor: "#2977A4",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 16px",
        }}
      >
        {title.map((t, indx) => (
          <Text
            as="C2"
            style={{
              color: "#CCE6F6",
              width: indx === 0 ? 100 : 70,
            }}
            key={t}
          >
            {t}
          </Text>
        ))}
      </div>
      <div>
        {users.map((u, index) => (
          <div
            key={u.uid}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 16px",
              backgroundColor: index % 2 ? "transparent" : "white",
            }}
          >
            <div>
              <Text
                as="P1"
                bold
                style={{
                  color: "#232C2E",
                  width: 100,
                }}
              >
                {nameInitials(u.displayName)}
              </Text>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 70,
                backgroundColor: "#F5F7F8",
                padding: "4px 12px 4px 12px",
                borderRadius: 8,
              }}
            >
              <Text as="H4" bold style={{ color: "#232C2E" }}>
                {u?.holes.reduce(
                  (iterator, item) => iterator + item.grossToPar,
                  0,
                )}
              </Text>
              <Text as="C1" style={{ color: "#232C2E" }}>
                /
                {u?.holes.reduce(
                  (iterator, item) => iterator + item.maxGrossScore,
                  0,
                )}
              </Text>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 70,
                backgroundColor: "#F5F7F8",
                padding: "4px 12px 4px 12px",
                borderRadius: 8,
              }}
            >
              <Text as="H4" bold style={{ color: "#232C2E" }}>
                {u?.holes.reduce(
                  (iterator, item) => iterator + item.netToPar,
                  0,
                )}
              </Text>
              <Text as="C1" style={{ color: "#232C2E" }}>
                /
                {u?.holes.reduce(
                  (iterator, item) => iterator + item.maxNetScore,
                  0,
                )}
              </Text>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 70,
              }}
            >
              <Switch
                toggleInitioalState={u.isHomeCourse}
                isOn={u.isHomeCourse}
                handleToggle={(e) => e && setHomeCourse(u)}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

ListHeader.propTypes = {
  title: PropTypes.shape({
    map: PropTypes.func,
  }).isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string,
    }),
  ).isRequired,
  setHomeCourse: PropTypes.func.isRequired,
};

ConfirmScoreModal.propTypes = {
  courseName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  submitButtonDisable: PropTypes.bool.isRequired,
};
